/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentControllerTypeApiModel } from './equipment-controller-type';
import { OdometerUnitTypeApiModel } from './odometer-unit-type';
import { PriceMarginsApiModel } from './price-margins';
import { PriceTypeApiModel } from './price-type';
import { EquipmentTypeApiModel } from './equipment-type';
import { PriceTaxesApiModel } from './price-taxes';

export interface JobEquipmentApiModel {
  /**
   * Authorized item amount
   */
  authorized_amount?: number | null;
  /**
   * Authorized item price
   */
  authorized_price?: number | null;
  /**
   * Authorized price currency ISO code (Only if filling_price_type is \'currency\')
   */
  authorized_price_currency?: string | null;
  authorized_price_margins?: PriceMarginsApiModel;
  /**
   * Authorized price special account Id (Only if filling_price_type is \'special-account\')
   */
  authorized_price_special_account_id?: string | null;
  authorized_price_taxes?: PriceTaxesApiModel;
  authorized_price_type?: PriceTypeApiModel;
  /**
   * Authorized price unit - quantity or currency ISO code (Only if filling_price_type is \'special-account\')
   */
  authorized_price_unit?: string | null;
  /**
   * Authorized item quantity
   */
  authorized_quantity?: number | null;
  /**
   * AVI (automatic vehicle identification) Id value (optional)
   */
  avi_id?: string | null;
  /**
   * Item amount captured by check
   */
  captured_amount?: number | null;
  /**
   * Item price captured by check
   */
  captured_price?: number | null;
  /**
   * Item quantity captured by check
   */
  captured_quantity?: number | null;
  /**
   * Charged item amount
   */
  charged_amount?: number | null;
  /**
   * Charged item price
   */
  charged_price?: number | null;
  /**
   * Charged item quantity
   */
  charged_quantity?: number | null;
  /**
   * Charging item amount
   */
  charging_amount?: number | null;
  /**
   * Charging item price
   */
  charging_price?: number | null;
  /**
   * Charging item quantity
   */
  charging_quantity?: number | null;
  /**
   * Controller connection failed flag (Exists and set to true only if connection with controller failed)
   */
  connection_failed?: boolean | null;
  /**
   * Controller Id
   */
  controller_id?: string | null;
  controller_type?: EquipmentControllerTypeApiModel;
  /**
   * Equipment Id
   */
  equipment_id: string | null;
  /**
   * Controller input number
   */
  equipment_input_number?: number | null;
  /**
   * Ability to monitor the working condition flag
   */
  equipment_monitor_working_status?: number | null;
  /**
   * Controller output number
   */
  equipment_output_number?: number | null;
  equipment_type?: EquipmentTypeApiModel;
  /**
   * Error message (Exists only if controller send error message)
   */
  error_message?: string | null;
  /**
   * Goods code
   */
  goods_code?: string | null;
  /**
   * Goods title (optional)
   */
  goods_title?: string | null;
  /**
   * Item amount
   */
  item_amount?: number | null;
  /**
   * Item code (optional)
   */
  item_code?: string | null;
  /**
   * Item price
   */
  item_price?: number | null;
  /**
   * Item quantity
   */
  item_quantity?: number | null;
  /**
   * Item title (optional)
   */
  item_title?: string | null;
  /**
   * Odometer/engine hours value, up to two decimal digits (optional)
   */
  odometer?: number | null;
  odometer_unit?: OdometerUnitTypeApiModel;
  /**
   * Equipment charging status
   */
  status?: JobEquipmentApiModelStatusEnum | null;
  /**
   * Qr Code / Tag of vehicle or equipment value (optional)
   */
  vehicle_id?: string | null;
}
export enum JobEquipmentApiModelStatusEnum {
  WaitingForProcess = 'waiting-for-process',
  Processing = 'processing',
  ProcessingStopping = 'processing-stopping',
  ProcessingFinished = 'processing-finished',
  ProcessingFailed = 'processing-failed'
}
